import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';
import { PRIVACY_POLICY } from './constants';

export const programId = '625607302ee68d6a1b605c09';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    marketConsent: {
        enabled: true,
        required: false,
    },
    privacyPolicyUrl: PRIVACY_POLICY,
};
